import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

import moment from "moment";
import "moment-timezone";

const timeZones = moment.tz.names();

const timeZoneOptions = timeZones.map(zone => {
  return {
    text: zone,
    value: zone
  };
});

const state = {
  horizontalMenu: false,
  miniSidebarMenu: false,
  organization: {},
  user: {},
  lang: {
    title: "Español",
    value: "sp",
    image: require("../../assets/images/flag/flag-sp.png"),
  },
  langOption: [
    {
      title: "Español",
      value: "sp",
      image: require("../../assets/images/flag/flag-sp.png"),
    },
    {
      title: "English",
      value: "en",
      image: require("../../assets/images/flag/flag-en.png"),
    },
    {
      title: "Català",
      value: "cat",
      image: require("../../assets/images/flag/flag-cat.png"),
    },
  ],
  colors: [
    {
      primary: "#827af3",
      primaryLight: "#b47af3",
      bodyBgLight: "#efeefd",
      bodyBgDark: "#1d203f",
    },
    {
      primary: "#827af3",
      primaryLight: "#b47af3",
      bodyBgLight: "#efeefd",
      bodyBgDark: "#1d203f",
    },
    {
      primary: "#e07af3",
      primaryLight: "#f37ab7",
      bodyBgLight: "#f7eefd",
      bodyBgDark: "#1d203f",
    },
    {
      primary: "#6475c7",
      primaryLight: "#7abbf3",
      bodyBgLight: "#eaf5ff",
      bodyBgDark: "#1d203f",
    },
    {
      primary: "#c76464",
      primaryLight: "#f3c37a",
      bodyBgLight: "#fff8ea",
      bodyBgDark: "#1d203f",
    },
    {
      primary: "#c764ad",
      primaryLight: "#de8ba9",
      bodyBgLight: "#ffeaf5",
      bodyBgDark: "#1d203f",
    },
    {
      primary: "#64c7ac",
      primaryLight: "#a3f37a",
      bodyBgLight: "#f0ffea",
      bodyBgDark: "#1d203f",
    },
    {
      primary: "#8ac764",
      primaryLight: "#dbf37a",
      bodyBgLight: "#f7ffea",
      bodyBgDark: "#1d203f",
    },
  ],
  activePage: {
    name: "Dashboard",
    breadCrumb: [
      {
        html: '<i class="ri-home-4-line mr-1 float-left"></i>Home',
        to: { name: "mini.dashboard.home-1" },
      },
      {
        text: "",
        href: "#",
      },
    ],
  },
  timeZoneOption: timeZoneOptions,
  timeZone: { text: "", value: "" },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
